import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"variable\":\"--font-plus-jakarta-sans\",\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"]}],\"variableName\":\"plusJakartaSans\"}");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["StoreProvider"] */ "/opt/buildhome/repo/providers/storeProvider.tsx");
